import { render, staticRenderFns } from "./RenegociacaoMenu.vue?vue&type=template&id=6ad0671c&scoped=true&"
import script from "./RenegociacaoMenu.vue?vue&type=script&lang=js&"
export * from "./RenegociacaoMenu.vue?vue&type=script&lang=js&"
import style0 from "./RenegociacaoMenu.vue?vue&type=style&index=0&id=6ad0671c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ad0671c",
  null
  
)

export default component.exports